import { render } from "./HeaderNotify.vue?vue&type=template&id=78830fe4&scoped=true"
const script = {}

import "./HeaderNotify.vue?vue&type=style&index=0&id=78830fe4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78830fe4"]])

export default __exports__